module.exports = __webpack_public_path__ + "img/andrea.0203bdaa.png";